import { render, staticRenderFns } from "./rich-list.vue?vue&type=template&id=a03bca6a&"
import script from "./rich-list.vue?vue&type=script&lang=js&"
export * from "./rich-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports